var map = {
	"./addAttachment.gif": "0080",
	"./addTodo.gif": "1f33",
	"./completingItem.gif": "229c",
	"./deleteAttachment.gif": "cba2",
	"./deleteItem.gif": "59c5",
	"./editItem.gif": "67c5",
	"./viewAttachments.gif": "d25e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "56e0";